import React, { useEffect, useState } from 'react';
import Header from '../Header/Header';
import Leagues from '../Leagues/Leagues';

const Home = () => {
    const [leagues, setLeagues] = useState([])
    useEffect(() => {
        const url = "https://www.thesportsdb.com/api/v1/json/1/all_leagues.php"
        fetch(url)
            .then(res => res.json())
            .then(data => setLeagues(data.leagues))
    }, [])
    return (
        <div style={{backgroundColor:"navy"}}>
            <Header></Header>
            <div style={{ marginTop: "20px" }}>
            
            <div className="container">
                <div className="row g-3 p-3 g-lg-5">
                        {
                            leagues.splice(0,20).map(league => <Leagues key={league.idLeague} league={league}></Leagues>)
                        }
               </div>
            </div>
        </div>
        </div>
    );
};

export default Home;